/* global axios */
import ApiClient from './ApiClient';

class WhatsappCatalogsAPI extends ApiClient {
  constructor() {
    super('catalogs', { accountScoped: true });
  }

  settings(inboxId) {
    return axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/inboxes/${inboxId}/catalogs/settings`
    );
  }

  updateSettings(inboxId, payload) {
    return axios.patch(
      `/api/v1/accounts/${this.accountIdFromRoute}/inboxes/${inboxId}/catalogs/settings`,
      payload
    );
  }
}

export default new WhatsappCatalogsAPI();
